import { HeaderContext } from '@tanstack/react-table';
import { capitalize } from 'lodash';
import { Ticket } from 'types/domain';

const transformTicketNumber = (value: string) => {
    const regex = /([a-zA-Z]+)(\d+)/;
    const match = regex.exec(value);

    if (match) {
        return match[1] + '-' + match[2];
    }

    return value;
};

type TicketTableKey = 'contact_name' | keyof Ticket;

const curriedTransformTableKeyToReadable = (header: HeaderContext<Ticket, unknown>) =>
    transformTableKeyToReadable(header.column.id as TicketTableKey);

const transformTableKeyToReadable = (key: TicketTableKey) => {
    if (key === 'contact_name') {
        return 'Contact';
    }

    return transactionPlanKeyToReadable(key);
};

const transactionPlanKeyToReadable = (key: keyof Ticket) => {
    switch (key) {
        case 'uid_suffix':
            return 'Number';
        case 'created_at':
            return 'Purchase date';
        case 'checked_in_at':
            return 'Status';
        case 'latest_checkin':
            return 'Checked in by';
        case 'custom_fields':
        case 'first_name':
        case 'last_name':
            return capitalize(key.split('_').join(' '));
        case 'type':
        case 'campaign':
        case 'phone':
        case 'email':
        case 'contact':
        case 'title':
        case 'pdf':
        case 'price':
            return capitalize(key);
        case 'id':
        case 'transaction_id':
        case 'primary_email':
        case 'contact_id':
        case 'campaign_item_id':
        case 'event':
        case 'revoked_at':
        case 'name':
        case 'discount':
            return 'Promo code';
        default:
            return key;
    }
};

export {
    transformTicketNumber,
    transformTableKeyToReadable,
    transactionPlanKeyToReadable,
    curriedTransformTableKeyToReadable,
};
export type { TicketTableKey };
